module.exports = __webpack_public_path__ + "static/media/19-8.adf17e3e.mp3";